export default __webpack_public_path__ + "static/footer-bg-63e70cf5704f31dae48922402d511ed8.svg";